import "./SinglePostTemplate.module.css"
import NavigationHeader from "@/reusable_sections/Header"
import SinglePostTemplate from "./sections/SinglePostTemplate"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <NavigationHeader />
      <SinglePostTemplate />
      <Footer />
    </div>
  )
}
